import React from 'react';
import styles from './completedPage.module.css';

const CompletedPage = ({evaluationPage}) => {
    const splitLines = (text) => {
        return text.split(/\r?\n/);
    };

    return (
        <div className={styles['completed-page-container']}>
            {evaluationPage.completedPageText
                ? splitLines(evaluationPage.completedPageText)
                    .map((line) => (<>{line}<br/></>))
                : "Your response has been recorded."
            }
        </div>
    );
};

export default CompletedPage;
